import React, { FC } from 'react';
import styled from 'styled-components';
import ConnectWallet from './ConnectWallet';

interface INavbarScrollerProps {
  brand: { name: string; to: string };
  links: Array<{ name: string, to: string }>;
  connectWallet: () => void;
  networkError?: string;
  dismiss: () => void;
}

const NavbarScroller: FC<INavbarScrollerProps> = ({ brand, links, connectWallet, networkError, dismiss }: INavbarScrollerProps) => {
  const NavLinks: any = () =>  links.map((link: { name: string, to: string }) => <Li key={link.name}><a href={link.to}>{link.name}</a></Li>);

  return (
    <Navbar>
      <Brand href={brand.to}>{brand.name}</Brand>
      <Ul>
        <ConnectWallet
          connectWallet={() => connectWallet()}
          networkError={networkError}
          dismiss={() => dismiss()}
        />
        <NavLinks />
      </Ul>
    </Navbar>
  )
};

export const Theme = {
  colors: {
    bg: `#fff`,
    dark: `#C4C4C4`,
    light: `#EEEEEE`,
    red: `#ff5851`,
  },
  fonts: {
    body: `IBM Plex Sans, sans-serif`,
    heading: `IBM Plex Sans, sans-serif`,
  }
}

export const Navbar = styled.nav`
  background: ${Theme.colors.dark};
  font-family: ${Theme.fonts.heading};
  color: ${Theme.colors.dark};
  display: flex;
  align-items: center;
  justify-content: space-between;
  a { color: black; text-decoration: none; }`;

export const Brand = styled.a`
  font-weight: bold;
  font-style: italic;
  margin-left: 1rem;
  padding-right: 1rem;`;

export const Ul = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  overflow: scroll;
  /* overflow-x: hidden; */
  -webkit-overflow-scrolling: touch;`;

export const Li = styled.li`
  flex: 0 0 auto;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  color: #999;
  height: 100%;
  justify-content: center;
  text-decoration: none;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  color: #999;
  display: flex;
  font-size: 14px;
  height: 50px;
  justify-content: center;
  line-height: 16px;
  margin: 0 1.125rem ;
  text-decoration: none;
  white-space: nowrap;`;

export { NavbarScroller };
